var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mt-5"},[_c('h2',[_vm._v("404 Page not found")]),_c('button',{staticClass:"btn btn-secondary mt-3",on:{"click":_vm.goBack}},[_vm._v("Back")])])
}
var staticRenderFns = []

export { render, staticRenderFns }